import { SITE_URL, CLINIC_REF } from "@/components/schemaConstants";

export const compareTreatmentsJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@context": "https://schema.org",
      "@type": "MedicalWebPage",
      name: "Compare Treatments for Treatment-Resistant Depression",
      description:
        "Side-by-side comparison of SAINT®, standard TMS, SPRAVATO®, ketamine and ECT for treatment-resistant depression: time, evidence, side effects, cost and insurance.",
      url: `${SITE_URL}/compare-treatments`,
      inLanguage: "en-US",
      isPartOf: { "@id": `${SITE_URL}/#website` },
      provider: CLINIC_REF,
      reviewedBy: {
        "@type": "Person",
        name: "Daniel Pietras, MD",
        url: `${SITE_URL}/dr-daniel-pietras-md`,
      },
      lastReviewed: "2026-10-01",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Which depression treatment works fastest?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "SAINT® and IV ketamine both act within days rather than weeks. In the 2022 SAINT randomized trial, the average time to remission was 2.6 days (Cole et al., Am J Psychiatry 2022;179(2):132–141). IV ketamine can produce relief within hours, though its use for depression is off-label and the effect often requires maintenance dosing. Standard TMS and ECT typically take weeks. Individual results may vary.",
          },
        },
        {
          "@type": "Question",
          name: "Can I combine SAINT with Spravato or ketamine?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Neuro Wellness offers SAINT®, SPRAVATO®, and IV ketamine under one roof, so a combined or sequential approach is possible when clinically appropriate. Some patients use an accelerated TMS course for durable remission and add SPRAVATO® or ketamine for interim relief or maintenance. The specific plan is set at a consultation based on your diagnosis and history.",
          },
        },
        {
          "@type": "Question",
          name: "Which treatments does insurance usually cover?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Standard TMS, deep TMS, SPRAVATO®, and ECT are generally covered by commercial plans and Medicare. SAINT® may be covered, but coverage varies by plan and is reviewed case by case through prior authorization; we verify your benefits for free. IV ketamine for depression is off-label and is generally not covered. Self-pay and financing options are available.",
          },
        },
        {
          "@type": "Question",
          name: "Which is best for me?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "There is no single best option — the right treatment depends on your diagnosis, how many antidepressants you have tried, how quickly you need relief, your tolerance for side effects, and your insurance. The interactive tool above lets you compare two or three treatments side by side, but a consultation with our clinical team is the only way to get a recommendation tailored to you.",
          },
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: `${SITE_URL}/`,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Compare Treatments",
          item: `${SITE_URL}/compare-treatments`,
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "MedicalClinic",
      name: "Neuro Wellness TMS Centers of America",
      url: SITE_URL,
      telephone: "+1-954-827-9793",
      address: {
        "@type": "PostalAddress",
        streetAddress: "9734 W Sample Rd",
        addressLocality: "Coral Springs",
        addressRegion: "FL",
        postalCode: "33065",
        addressCountry: "US",
      },
    },
  ],
};
